import PrivateRoute from "@ch/components/PrivateRoute";
import AuthRootPage from "@ch/pages/AuthRootPage/AuthRootPage";
import ErrorPage from "@ch/pages/ErrorPage";
import RootPage from "@ch/pages/RootPage/RootPage";
import { createBrowserRouter } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import { AppPathsEnum, AppRoutesEnum } from "./AppRoutes/enums";
import AuthRoutes from "./AuthRoutes";
import { AuthPathsEnum } from "./AuthRoutes/enums";

const router = createBrowserRouter([
  {
    path: AuthPathsEnum.ROOT,
    element: <AuthRootPage />,
    errorElement: <ErrorPage />,
    children: AuthRoutes,
  },
  {
    path: AppPathsEnum.ROOT,
    element: (
      <PrivateRoute>
        <RootPage />
      </PrivateRoute>
    ),
    errorElement: <ErrorPage />,
    children: AppRoutes,
    handle: {
      meta: () => ({
        title: "Dashboard",
        pageTitle: "Personal Dashboard",
      }),
      crumb: () => ({
        title: "Dashboard",
        route: AppRoutesEnum.ROOT,
        icon: "category",
      }),
    },
  },
]);

export default router;
